import { render, staticRenderFns } from "./ShokurekishoEdit.vue?vue&type=template&id=040c7cb6&scoped=true&"
import script from "./ShokurekishoEdit.vue?vue&type=script&lang=js&"
export * from "./ShokurekishoEdit.vue?vue&type=script&lang=js&"
import style0 from "./ShokurekishoEdit.vue?vue&type=style&index=0&id=040c7cb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040c7cb6",
  null
  
)

export default component.exports